import {
    Heading,
    Stack,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import StatusFailedIcon from "components/booking-status/status-failed-icon";
const StatusFailedWithDialogue = ({
    title,
    message,
}: {
    title: string;
    message: string | JSX.Element;
}) => {
    return (
        <Stack alignItems="center" spacing={ThemeSpaceVariable.Medium}>
            <StatusFailedIcon />
            <Stack spacing="none" alignItems="flex-start">
                <Heading as="h1" color="inherit" fontWeight="500" mb={ThemeSpaceVariable.Small}>
                    {title}
                </Heading>
                <Text fontSize={ThemeFontSizeVariable.Large}>{message}</Text>
            </Stack>
        </Stack>
    );
};

export default StatusFailedWithDialogue;
